import { styled, Stack } from '@mui/material';

export const IconContent = styled(Stack)(() => ({
  color: '#fff',
  borderRadius: '50%',
  height: 28,
  width: 28,
  justifyContent: 'center',
  alignItems: 'center',
  svg: {
    height: 18,
    width: 18,
  },
}));
